import React from 'react'
import './Report.sass'
import {Link} from "react-router-dom";

export default props =>
  <div className='report'>
    <div className="report-btn">
      <Link
        to='/modules/reply'
        className="report-btn__item"
        onSubmit={() => console.log('Submitted')}
        onClick={props.onClick}
      >Отчет</Link>
      {props.showSave
        ? <button
            className="report-btn__item"
            onSubmit={() => console.log('Submitted')}
            onClick={props.onClick}
          >Сохранить</button>
        : null
      }
    </div>
  </div>